import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useParams } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';
import styled from 'styled-components';
import { getDocumentContent } from '../features/activity/utils/activity';
import { isLoggedIn } from '../features/authentication/utils/auth';
import NavBar from '../layouts/NavBar';

export const StyledBox = styled.div`
	position: relative;
	width: 70%;
	margin: 0 auto;
	height: auto;
	max-height: 80vh;
	margin-top: calc(90vh - 80vh - 30px);
	background: #fff;
	border-radius: 4px;
	padding: 20px;
	border: 2px solid #999;
	overflow: auto;
`;
const File = () => {
	const { id } = useParams();
	const [document, setDocument] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchDocumentContent = async () => {
			try {
				const documentContent = await getDocumentContent(id);
				if (documentContent) {
					setDocument(documentContent);
				} else {
					setError({ message: 'Document introuvable!' });
				}
			} catch (err) {
				setError(err);
			}
		};
		fetchDocumentContent();
	}, [id]);

	if (!isLoggedIn()) {
		return <Navigate to="/" state={{ from: `/file/${id}` }} />;
	}

	if (document) {
		const url = `data:${document.mimeType};base64,${document.content}`;
		const extensionPart = document.fileName.split('.');
		const extension = extensionPart[1];

		if (extension === 'pdf') {
			return (
				<>
					<NavBar />
					<NotificationContainer />
					{extension === 'pdf' && (
						<StyledBox>
							<object
								type={document.mimeType}
								data={url}
								width={1300}
								height={700}
							></object>
						</StyledBox>
					)}
				</>
			);
		}
		if (extension !== 'pdf') {
			return (
				<>
					<NavBar />
					<StyledBox>
						<img src={url} alt={document.fileName} />
					</StyledBox>
				</>
			);
		}
	}
	if (error) {
		return (
			<>
				<NavBar />
				<p>Error: {error.message}</p>
			</>
		);
	}
	return (
		<>
			<NavBar />
			<StyledBox></StyledBox>
		</>
	);
};

File.propTypes = {
	id: PropTypes.string,
};

export default File;
